const task = {
	name: 'Task | Tasks',
	icon: 'fa-fw fa-solid fa-clipboard-list-check',
	fields: {
		task_type: {
			name: 'Type',
		},
		text: 'Description',
		due_date: 'Due date',
		team_id_assigned: 'Assigned to',
	},
}

export default task
